module.exports = __webpack_public_path__ + "img/data-centers-and-system-solutionsimg-2.c229b416.png";